import { styled } from '@mui/material';

export const LogicContainer = styled('div')<{ $isLastItem: boolean }>`
  border-left: ${({ theme }) => theme.borders.shorthand(2)};
  border-right: ${({ theme }) => theme.borders.shorthand(2)};
  border-bottom: ${({ theme, $isLastItem }) =>
    $isLastItem ? theme.borders.shorthand(2) : 'none'};
`;
